'use strict';

var DropDownList = {
    dropDownList: [],

    initialize: function (element, options) {
        this.attachResizingEvent(element, options);

        var idx = element.attr('data-ddl');
        var ddl = this.dropDownList[parseInt(idx)];
        if (!idx || !ddl) return;

        this.attachEventHandler(element, element.closest('div').find('div.bs-searchbox input'), ddl, 'keyup', options);
        this.attachEventHandler(element, element, ddl, 'shown.bs.select', options);
        element
            .closest('div')
            .find('div.bs-searchbox input')
            .on('keydown', function (e) {
                if (e.keyCode == 13) {
                    setTimeout(function () {
                        var v = element.val();
                        if (v != lastValue) {
                            element.change();
                        }
                    });
                }
            });

        var lastValue = element.val();
        element.on('change', function (e) {
            lastValue = element.val();
        });

        element.closest('div').on('click', function (e) {
            setTimeout(function () {
                var v = element.val();
                if (v != lastValue) {
                    element.change();
                }
            });
        });

        this.update3State(element);
    },

    update3State: function (element) {
        var self = this;
        if (element.attr('data-can-exclude') != 'true') return;

        var $div = element.closest('div');
        element.on('shown.bs.select', function () {
            setTimeout(function () {
                self.update3StateText($div.find('button.dropdown-toggle'), $div.find('li'));
            });
        });

        var $options = element.find('option');
        _.each($options, function (opt, idx) {
            var $opt = $(opt);
            if ($opt.attr('data-excluded') != 'true') {
                return;
            }

            // locate li
            var $li = element.closest('div').find('li[data-original-index="' + idx + '"]');
            self.setExcluded($li, element);
        });
    },

    setExcluded: function (li, element) {
        li.addClass('excluded');
        // change the symbol
        var $cm = li.find('.check-mark');
        $cm.addClass('fa');
        $cm.addClass('fa-minus');
        $cm.removeClass('glyphicon');
        $cm.removeClass('glyphicon-ok');
        var $div = element.closest('div');
        this.update3StateText($div.find('button.dropdown-toggle'), $div.find('li'));
    },

    update3StateText: function ($button, $li) {
        var $span = $button.find('span.filter-option');
        var items = _.map($li, function (item) {
            var text = $(item).find('span.text').text();
            var selected = $(item).hasClass('selected');
            var excluded = $(item).hasClass('excluded');
            if (!selected) return undefined;
            return (
                '<span class="' + (excluded ? 'excluded' : '') + '">' + Handlebars.escapeExpression(text) + '</span>'
            );
        });
        $span.html(_.compact(items).join(', '));
    },

    attachResizingEvent: function (element, options) {
        var self = this;
        var $el = $(element);
        $el.selectpicker(options).on('shown.bs.select', function () {
            var $parent = $(element).closest('.bootstrap-select');
            var width = $parent.outerWidth() * 1.3;
            width = Math.min(width, document.documentElement.clientWidth - 160);
            $parent.find('li span.text').css('max-width', '' + width + 'px');
        });

        if (element.attr('data-can-exclude') == 'true') {
            var $div = $el.closest('div');
            var $button = $div.find('button.dropdown-toggle');
            var $ul = $div.find('ul');
            var $li = $ul.find('li');
            var $a = $li.find('a');
            $li.on('click', function (d) {
                var $t = $(d.currentTarget);

                var excluding = $t.hasClass('selected') && !$t.hasClass('excluded');
                var including = $t.hasClass('selected') && $t.hasClass('excluded');
                // selected => excluded
                if (excluding) {
                    self.setExcluded($t, element);
                    d.stopPropagation();
                }

                if (including) {
                    $t.removeClass('excluded');
                    // change the symbol
                    var $cm = $t.find('.check-mark');
                    $cm.removeClass('fa');
                    $cm.removeClass('fa-minus');
                    $cm.addClass('glyphicon');
                    $cm.addClass('glyphicon-ok');
                }

                setTimeout(function () {
                    self.update3StateText($button, $li);
                });
            });
        }
    },

    updateSelected: function (el, content) {
        var selected = el.val() || '';
        if (selected.split) selected = selected.split(',');

        var all = {};
        _.each($(el).find('option'), function (item) {
            var value = $(item).attr('value');
            all[value] = selected.indexOf(value) != -1;
        });

        _.each(content.allItems, function (item) {
            var isSelected = undefined;
            var selectedAttr = undefined;

            _.each(item.attrs, function (attr, idx) {
                if (attr.key == 'selected') {
                    isSelected = attr.value == 'selected';
                    selectedAttr = idx;
                }
            });

            if (all[item.value] !== undefined && isSelected != all[item.value]) {
                if (!selectedAttr) {
                    selectedAttr = item.attrs.length;
                    item.attrs.push({ key: 'selected', value: 'selected' });
                }

                if (all[item.value]) {
                    item.attrs[selectedAttr].value = 'selected';
                } else {
                    item.attrs.splice(selectedAttr, 1);
                }
            }
        });
    },

    attachEventHandler: function (element, sender, ddl, event, options) {
        var self = this;
        sender.on(event, function (e) {
            if (ddl.inEventHandler) {
                return;
            }
            if (e.keyCode == 38 || e.keyCode == 40) return;
            var value = $(element).closest('div').find('div.bs-searchbox input').val();
            ddl.inEventHandler = true;
            self.updateSelected(element, ddl.content);
            var html = self.buildOptions(ddl.content, ddl.maxItems, value);
            $(element).html(html);
            $(element).selectpicker('refresh');
            self.update3State(element);
            self.attachResizingEvent(element, options);
            sender.trigger(event, e);
            self.displayCount(element, ddl.content);
            ddl.inEventHandler = false;
        });
    },

    displayCount: function (el, content) {
        var $ownerDiv = $(el).closest('div');
        var $input = $ownerDiv.find('ul');
        var $li = $input.find('li[data-original-index]:not(.hidden)');
        if ($ownerDiv.find('.dropdown-ddl-count').length == 0 && $li.length != content.options.length) {
            var elCnt = document.createElement('div');
            var $elCnt = $(elCnt);
            $elCnt.addClass('dropdown-ddl-count');
            $ownerDiv.find('div.bs-searchbox').append(elCnt);
            $ownerDiv.find('.dropdown-menu.inner').css('max-height', '-=10px');
        }

        $ownerDiv.find('.dropdown-ddl-count').html($li.length + '/' + content.options.length);
    },

    create: function (newElement, selectedValues, maxItems) {
        maxItems = maxItems || 200;
        var selectEl = $(newElement).find('select')[0];
        var selectedValStrings = _.map(selectedValues, function (item) {
            return '' + item;
        });

        // build the content: collect data about all options and optgroups
        var content = this.parseContent(selectEl, newElement, selectedValStrings);
        // pick first XX items and build HTML for them
        $(selectEl).html(this.buildOptions(content, maxItems));
        // register the control
        var idx = this.dropDownList.length || 1;
        this.dropDownList[idx] = {
            content: content,
            maxItems: maxItems,
        };
        // add the id to the control
        $(selectEl).attr('data-ddl', idx);
    },

    parseContent: function (selectEl, newElement, selectedValStrings) {
        var result = {
            allItems: [],
            topItems: [],
            leaves: [],
            options: [],
            selected: [],
        };

        var parseChildren = function (list, childrenList, ownerIdx) {
            _.each(childrenList, function (item) {
                var newItem = {
                    name: item.localName,
                    idx: result.allItems.length,
                    subItems: [],
                    attrs: [],
                    ownerIdx: ownerIdx,
                    value: undefined,
                    content: undefined,
                };
                result.allItems.push(newItem);
                list.push(newItem.idx);

                // attributes
                _.each(item.attributes, function (attr) {
                    newItem.attrs.push({ key: attr.name, value: attr.value });
                    if (attr.name.toLowerCase() == 'value' && item.localName.toLowerCase() == 'option') {
                        result.options.push(newItem.idx);
                        var itemValue = attr.value;
                        if (selectedValStrings.indexOf(itemValue) != -1) {
                            result.selected.push(newItem.idx);
                        }
                        newItem.value = itemValue;
                    }
                });

                // content
                if (item.children.length == 0) {
                    newItem.content = item.innerHTML;
                    result.leaves.push(newItem.idx);
                } else {
                    parseChildren(newItem.subItems, item.children, newItem.idx);
                }
            });
        };

        parseChildren(result.topItems, selectEl.children, undefined);
        return result;
    },

    buildOptions: function (content, maxItems, filter) {
        // pick selected items
        var newItems = [];
        newItems.push.apply(newItems, content.selected);

        var i = 0;
        var added = 0;
        while (added < maxItems && i < content.leaves.length) {
            var itm = content.leaves[i];
            if (newItems.indexOf(itm) == -1) {
                if (!filter || content.allItems[itm].content.toLowerCase().indexOf(filter.toLowerCase()) > -1) {
                    newItems.push(itm);
                    added++;
                }
            }
            i++;
        }

        newItems = _.uniq(
            _.sortBy(newItems, function (x) {
                return x;
            })
        );
        return this.buildHTML(content, newItems);
    },

    buildHTML: function (content, list) {
        var html = '';
        var usedItems = {};

        // add at least one item
        var newList = _.flatten([list, list.length || content.leaves.length == 0 ? [] : [content.leaves[0]]]);
        var addToUsedItems = function (item) {
            usedItems[item] = true;
            var ownerIdx = content.allItems[item].ownerIdx;
            if (ownerIdx !== undefined) addToUsedItems(ownerIdx);
        };

        _.each(newList, function (listItem) {
            addToUsedItems(listItem);
        });

        var buildCode = function (list) {
            var code = '';
            _.each(list, function (idx) {
                if (!usedItems[idx]) return;

                var item = content.allItems[idx];
                code += '<' + item.name;
                _.each(item.attrs, function (attr) {
                    code += ' ' + attr.key + '="' + attr.value + '"';
                });
                code += '>';

                // add subitems
                code += buildCode(item.subItems);
                // add content
                if (item.content) code += item.content;
                // close tag
                code += '</' + item.name + '>';
            });
            return code;
        };
        return buildCode(content.topItems);
    },
};

module.exports = {
    initialize: function (element, options) {
        return DropDownList.initialize(element, options);
    },

    create: function (newElement, selectedValues) {
        return DropDownList.create(newElement, selectedValues);
    },
};
